"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var auth_1 = require("@8base-react/auth");

var ApolloContainer_1 = require("./ApolloContainer");

var table_schema_provider_1 = require("@8base-react/table-schema-provider");
/**
 * `AppProvider` universal provider which loads fragments schema and provides Apollo client with it, authentication and table schema.
 * @prop {string} [uri] - The 8base API field schema.
 * @prop {string} [subscriptionUri] Endpoint of the GraphQl websocket server.
 * @prop {Object} [authClient] - The 8base auth client.
 * @prop {Function} [onRequestSuccess] - The callback which called when request is success.
 * @prop {Function} [onRequestError] - The callback which called when request is fail.
 * @prop {Function} [extendLinks] - Function to extend standart array of the links.
 * @prop {Function|React.ReactNode} [children] - The render function or React nodes.
 * @prop {Object} [introspectionQueryResultData] - The fragment type for introspection fragments matcher.
 * @prop {Object} [tablesList] - The schema of the 8base tables.
 * @prop {Object} [cacheOptions] - Apollo InMemoryCache options.
 */


var AppProvider = function AppProvider(_ref) {
  var uri = _ref.uri,
      subscriptionUri = _ref.subscriptionUri,
      authClient = _ref.authClient,
      onRequestSuccess = _ref.onRequestSuccess,
      onRequestError = _ref.onRequestError,
      extendLinks = _ref.extendLinks,
      children = _ref.children,
      autoSignUp = _ref.autoSignUp,
      authProfileId = _ref.authProfileId,
      introspectionQueryResultData = _ref.introspectionQueryResultData,
      tablesList = _ref.tablesList,
      applicationsList = _ref.applicationsList,
      withSubscriptions = _ref.withSubscriptions,
      cacheOptions = _ref.cacheOptions;

  var renderApolloContainer = function renderApolloContainer(apolloContainerProps) {
    return react_1.default.createElement(ApolloContainer_1.ApolloContainer, Object.assign({
      withSubscriptions: withSubscriptions,
      uri: uri,
      subscriptionUri: subscriptionUri,
      extendLinks: extendLinks,
      onRequestSuccess: onRequestSuccess,
      onRequestError: onRequestError,
      introspectionQueryResultData: introspectionQueryResultData,
      cacheOptions: cacheOptions
    }, apolloContainerProps), react_1.default.createElement(table_schema_provider_1.TableSchemaProvider, {
      tablesList: tablesList,
      applicationsList: applicationsList
    }, children));
  };

  return !!authClient ? react_1.default.createElement(auth_1.AuthProvider, {
    authClient: authClient
  }, renderApolloContainer({
    withAuth: true,
    autoSignUp: autoSignUp,
    authProfileId: authProfileId
  })) : renderApolloContainer({
    withAuth: false
  });
};

exports.AppProvider = AppProvider;